import { hexToRgba, hslToRgb, rgbaToHex, rgbToHsl } from 'tools/colorHelpers';

// getDarkColor() backwards, only nearly: that one squeezes the middle colors, so it can't be undone exactly
export function getLightColor(dark: string): string {
	if (!dark?.startsWith('#')) {
		return dark;
	}

	const { r, g, b, a } = hexToRgba(dark);
	const { h, s, l } = rgbToHsl({ r, g, b });
	const light = hslToRgb({ h, s: Math.min(100, s / 0.85), l: getLightLightness(l) });

	return rgbaToHex(light.r, light.g, light.b, a < 1 ? a : undefined);
}

// getDarkColor() gives no lightness between its backgrounds and its middle colors, nor between those and its
// texts: a color picked there goes to the nearer side
function getLightLightness(l: number) {
	if (l < 34) {
		return Math.min(100, 100 - (l - 8) / 1.2);
	}

	if (l > 76.5) {
		return Math.max(0, (92 - l) / 0.7);
	}

	return l - 5;
}
